module.exports = __webpack_public_path__ + "media/images/new_landing/people/marek-bendik-8752edccfddfa28b9c1bbd0e279b36dc.jpg";